import { Link } from "components/elements";
import { STATUS_LABELS } from "hooks/tivoApps";
import { NO_VALUE_PLACEHOLDER } from "src/constants";
import { pathToUrl } from "utils/url";

import { DEFAULT_PATHS, PATHS } from "../constants";
import { TEXTS } from "./constants";

type GetPageHeaderProps = {
  id: string | undefined; // provider unique id
  appName: string | undefined;
  variantName: string | undefined;
};

export function formatGroup<T extends string | number>(
  values?: T[] | null,
  labels?: Record<T, string>
) {
  return values && labels
    ? values
        .map((value) => labels[value])
        .filter((value) => value)
        .join(", ")
    : NO_VALUE_PLACEHOLDER;
}

export function getPageHeader({
  id,
  appName,
  variantName,
}: GetPageHeaderProps) {
  // Provider Details
  if (id && !variantName) {
    return appName || "App";
  }

  // Variant Details
  if (appName && variantName) {
    const providerDetailsPath = pathToUrl(PATHS.detailsProvider, {
      id,
      tabId: DEFAULT_PATHS.APP_DETAILS,
    });

    return (
      <>
        <Link to={providerDetailsPath}>{appName}</Link> | {variantName}
      </>
    );
  }

  return "";
}

export function getReleaseTabId(releaseStages: string[] | undefined) {
  if (!releaseStages) {
    return "draft";
  }
  if (releaseStages.length === 0) {
    return "submitted";
  }
  return releaseStages.join("-");
}

export function getReleaseTabLabel(
  releaseStages: string[] | undefined,
  releaseLabel: string,
  newestReleaseLabel: string
) {
  if (!releaseStages) {
    return STATUS_LABELS.draft;
  }
  if (releaseStages.length === 0) {
    return TEXTS.VARIANT.SUBMITTED_TAB_LABEL;
  }
  let tabLabel = releaseStages
    .toSorted()
    .map((rs) => rs.toUpperCase())
    .join(", ");
  if (releaseLabel !== newestReleaseLabel) {
    tabLabel += ` (${releaseLabel})`;
  }
  return tabLabel;
}
